import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import translate from '../../../../commonComponents/translate';
import FastBonusCard from './FastBonusCard';

const FastStartBonus = props => {
  const {
    t,
    collaboratorDate,
    achievedFastStart1,
    achievedFastStart2,
    achievedFastStart3,
  } = props;

  const bonusData = [
    {
      commission: 50,
      daysRemaining: moment(collaboratorDate)
        .add(30, 'days')
        .diff(moment(), 'day'),
      bonusAchieved: achievedFastStart1,
    },
    {
      commission: 50,
      daysRemaining: moment(collaboratorDate)
        .add(60, 'days')
        .diff(moment(), 'day'),
      bonusAchieved: achievedFastStart2,
    },
    {
      commission: 100,
      daysRemaining: moment(collaboratorDate)
        .add(90, 'days')
        .diff(moment(), 'day'),
      bonusAchieved: achievedFastStart3,
    },
  ];

  return (
    <div className="fast-start-bonus">
      <div className="fast-start-bonus-header">
        <div className="career-section-title">
          {t('report.laborigin.fastStartBonus')}
        </div>
        {collaboratorDate && (
          <div className="career-section-subtitle">
            {`${t(
              'report.laborigin.fastStartBonus.collaboratorSince',
            )}  ${moment(collaboratorDate).format('DD/MM/YYYY')}`}
          </div>
        )}
      </div>
      <div className="fast-start-bonus-content">
        {bonusData.map((bonus, index) => (
          <FastBonusCard
            key={index}
            t={t}
            index={index}
            bonusData={bonus}
            bonusDescription={t(
              `report.laborigin.fastStartBonus.bonus${index + 1}`,
            )}
          />
        ))}
      </div>
    </div>
  );
};

FastStartBonus.propTypes = {
  t: PropTypes.func.isRequired,
  collaboratorDate: PropTypes.number.isRequired,
  achievedFastStart1: PropTypes.bool.isRequired,
  achievedFastStart2: PropTypes.bool.isRequired,
  achievedFastStart3: PropTypes.bool.isRequired,
};

export default translate(FastStartBonus);
